import { Plan } from '../../types/plans';

/**
 * Produce a stable item name used across analytics events.
 * Format: "<product> - prime - <term>"
 * where <term> is the plan's human-readable item name using a singular 'month' (e.g. "12 month").
 */
export function formatItemName(
  plan: Plan,
  itemName?: string,
  subscriptions?: any[],
) {
  const [product] = (plan.code || '').split('-');

  const isAnnualSubscription =
    subscriptions &&
    subscriptions.length > 0 &&
    subscriptions.every((s) => s.autoRenew) &&
    plan.intervalLength > 1;

  const isMonthlySubscription =
    subscriptions &&
    subscriptions.length > 0 &&
    subscriptions.every((s) => s.autoRenew) &&
    plan.intervalLength === 1;

  const prefix = `${product} - prime -`;

  // Use singular 'month' for numerical durations so names are like "12 month" or "1 month"
  if (isMonthlySubscription) return `${prefix} 1 month`;
  if (isAnnualSubscription)
    return `${prefix} ${itemName || `${plan.intervalLength} month`}`;

  return `${prefix} ${itemName || `${plan.intervalLength} month`}`;
}

export default formatItemName;
